export default "__VITE_PUBLIC_ASSET__c794630c__"